<template>

  <BasicLayout>

    <div>

      <!-- SEARCH -->
      <Search :searching="searching"
              @search="search"
              @closeSearch="searching = false"
              @clearSearch="clearSearch"/>

      <div class="elevation-2">

        <!-- TOOLBAR -->
        <v-toolbar flat="flat">
          <v-toolbar-title>Clubs</v-toolbar-title>
          <v-flex class="ml-5" md3="md3">
            <v-text-field v-show="!loading && !searching"
                          v-model="quickSearchID"
                          placeholder="Search by ID"
                          :clearable="true"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-icon class="mr-2"
                  v-if="!searching"
                  title="Show the search"
                  @click="searching = true">mdi-magnify</v-icon>
          <v-icon title="Create club"
                  @click="dialog = true">mdi-plus</v-icon>
        </v-toolbar>

        <!-- TABLE -->
        <Table :headers="headers"
               :items="items"
               :pagination="pagination"
               :paginationOptions="paginationOptions"
               :totalItems="pagination.totalItems"
               :loading="loading"
               @paginationUpdate="paginationUpdate"
               @edit="toggleEdit"
               @del="del"/>

        <!-- CREATE / EDIT -->
        <Dialog :dialog="dialog"
                :dialogState="dialogState"
                :currentEditedClub="editedItem"
                :errorMessage="errorMessage"
                @dialogClosed="close"
                @createClub="createClub"
                @editClub="editClub"/>

      </div>
    </div>

    <!-- CONFIRM DELETE CLUB WITH TEAMS/VIDEOS -->
    <ConfirmPopup :isActive="deleteConfirmToggled"
                  :title="'Warning : this club has teams and/or videos'"
                  :text="'If you confirm delete, all teams and videos on this club will be deleted\n\nThis action is irreversible'"
                  :cancelButtonText="'Cancel'"
                  :confirmButtonText="'Delete'"
                  @cancel="cancelDeleteConfirm"
                  @confirm="confirmDeleteConfirm"/>

  </BasicLayout>

</template>

<script>

import BasicLayout from '../layouts/BasicLayout'
import Search from '../components/clubs/Search'
import Table from '../components/clubs/Table'
import Dialog from '../components/clubs/Dialog'
import ConfirmPopup from '../components/common/ConfirmPopup'

export default {
  name: 'ClubsPage',
  components: {
    BasicLayout,
    Search,
    Table,
    Dialog,
    ConfirmPopup
  },
  data () {
    return {
      loading: false,

      items: [],

      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Logo',
          value: 'logoURL',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Alias',
          value: 'alias',
          sortable: false,
          width: '200px',
          countries: ['FR', 'US']
        },
        {
          text: 'Sport',
          value: 'sportID',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
          width: '1%',
          countries: ['US']
        },
        {
          text: 'Region',
          value: 'regionName',
          sortable: false,
          width: '200px',
          countries: ['FR', 'US']
        }
      ],

      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      paginationOptions: [10, 50, 100],

      dialog: null,
      editedItem: null,
      editedIndex: -1,

      errorMessage: '',

      quickSearchID: null,

      searching: false,
      searchParams: {},

      deleteConfirmToggled: false,
      deleteConfirmClub: null
    }
  },
  mounted () {
    this.setHeaders()
    this.loadData()
  },
  methods: {
    setHeaders () {
      this.headers = this.headers.filter(item => item.countries.includes(this.$country))
    },
    loadData () {
      this.loading = true
      this.searching = false

      let params = {
        page: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        withTotalItems: true,
        avoidCache: true
      }

      if (this.searchParams.name) {
        params.name = this.searchParams.name
      }
      if (this.searchParams.sportID) {
        params.sportID = this.searchParams.sportID
      }
      if (this.searchParams.type) {
        params.type = this.searchParams.type
      }

      this.$store.dispatch('searchClubs', params)
        .then(resp => {
          this.pagination.totalItems = resp.totalItems
          this.items = resp.items
          this.loading = false
        })
        .catch(() => {
          alert('Error loading clubs')
          this.loading = false
        })
    },

    search (params) {
      this.pagination = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
      this.searchParams = params
      this.loadData()
    },

    clearSearch () {
      this.searchParams = {
        name: null,
        sportID: null,
        type: null
      }
    },

    toggleEdit (index) {
      this.editedIndex = index
      this.editedItem = JSON.parse(JSON.stringify(this.items[index]))
      this.dialog = true
    },

    del (club) {
      this.$store.dispatch('deleteClub', club.id)
        .then(() => {
          this.loadData()
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.deleteConfirmToggled = true
            this.deleteConfirmClub = club
          } else {
            alert('Error deleting club')
          }
        })
    },
    cancelDeleteConfirm () {
      this.deleteConfirmClub = null
      this.deleteConfirmToggled = false
    },
    confirmDeleteConfirm () {
      this.$store.dispatch('confirmDeleteClub', this.deleteConfirmClub.id)
        .then(() => {
          this.deleteConfirmClub = null
          this.deleteConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          alert('Error deleting club')
        })
    },

    createClub (club) {
      if (this.checkFields(club)) {
        return
      }

      if (club.logo.file) {
        this.uploadLogo(club.logo.file)
          .then(logourl => {
            club.logoURL = logourl
            delete club.logo
            this.$store.dispatch('createClub', club)
              .then(resp => {
                this.showCreatedClub(resp.id)
                this.close()
              })
              .catch(() => {
                alert('Error creating club')
              })
          })
      } else {
        if (club.logo.url) {
          club.logoURL = club.logo.url
        }
        delete club.logo
        this.$store.dispatch('createClub', club)
          .then(resp => {
            this.showCreatedClub(resp.id)
            this.close()
          })
          .catch(() => {
            alert('Error creating club')
          })
      }
    },

    editClub (editedclub) {
      let club = JSON.parse(JSON.stringify(editedclub))
      if (this.checkFields(club)) {
        return
      }

      if (club.logo.file) {
        this.uploadLogo(club.logo.file)
          .then(logourl => {
            club.logoURL = logourl
            delete club.logo
            this.$store.dispatch('patchClub', {
              id: this.items[this.editedIndex].id,
              patch: club
            })
              .then(() => {
                this.updateItem(this.editedIndex, club)
                this.close()
              })
              .catch(() => {
                alert('Error editing club')
              })
          })
      } else {
        if (club.logo.url) {
          club.logoURL = club.logo.url
        }
        delete club.logo
        this.$store.dispatch('patchClub', {
          id: this.items[this.editedIndex].id,
          patch: club
        })
          .then(() => {
            this.updateItem(this.editedIndex, club)
            this.close()
          })
          .catch(() => {
            alert('Error editing club')
          })
      }
    },

    showCreatedClub (id) {
      this.$store.dispatch('getClub', id)
        .then(resp => {
          this.items = [resp]
        })
    },

    updateItem (index, patch) {
      this.items[index].name = patch.name
      this.items[index].alias = patch.alias
      this.items[index].logoURL = patch.logoURL || null
      this.items[index].sportID = patch.sportID
      this.items[index].federationID = patch.federationID
      this.items[index].regionID = patch.regionID

      if (patch.type) {
        this.items[index].type = patch.type
      }
    },

    uploadLogo (file) {
      return new Promise((resolve, reject) => {
        let filename = Date.now().toString() + '.jpg'
        this.$store.dispatch('uploadClubLogo', {
          file: file,
          name: filename
        })
          .then(() => {
            let url = ''
            if (this.$country === 'FR') {
              url = `https://rematch-public.b-cdn.net/logos/clubs/${filename}`
            } else {
              url = `https://rematch-us-public.b-cdn.net/logos/clubs/${filename}`
            }
            resolve(url)
          })
          .catch(err => {
            alert('Error uploading club logo')
            reject(err)
          })
      })
    },

    paginationUpdate (v) {
      if (this.pagination.page !== v.page || this.pagination.rowsPerPage !== v.rowsPerPage) {
        this.pagination = {
          page: v.page,
          rowsPerPage: v.rowsPerPage,
          totalItems: this.pagination.totalItems
        }
        this.loadData()
      }
    },

    checkFields (club) {
      if (!club.name) {
        this.errorMessage = 'Please enter a name'
        return true
      }

      if (!club.alias) {
        this.errorMessage = 'Please enter an alias'
        return true
      }

      if (!club.sportID) {
        this.errorMessage = 'Please select a sport'
        return true
      }

      if (!club.federationID) {
        this.errorMessage = 'Please select a federation'
        return true
      }

      if (!club.regionID) {
        this.errorMessage = 'Please select a region'
        return true
      }

      if (!club.type && (this.$country === 'US')) {
        this.errorMessage = 'Please select a club type'
        return true
      }

      return false
    },

    close () {
      this.dialog = false
      this.editedItem = null
      this.editedIndex = -1
      this.errorMessage = ''
    }
  },
  computed: {
    dialogState () {
      return this.editedIndex === -1 ? 'create' : 'edit'
    }
  },
  watch: {
    'quickSearchID' () {
      if (this.quickSearchID) {
        if (this.quickSearchID.length !== 20) {
          this.quickSearchID = null
          return
        }
        this.loading = true
        this.$store.dispatch('getClub', this.quickSearchID)
          .then(resp => {
            this.items = [resp]
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading club')
          })
      } else {
        this.loadData()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/ClubsPage.vue